module.exports = __webpack_public_path__ + "img/learn-4-dark.c12ea843.png";